// src/components/admin/users/BusinessInvoicesAdmin.jsx
import { useEffect, useState } from "react";
import {
  subscribeUserInvoices,
  uploadInvoicePdf,
  removeInvoice,
} from "../../../services/invoicesService";

export default function BusinessInvoicesAdmin({ uid }) {
  const [list, setList] = useState([]);
  const [file, setFile] = useState(null);
  const [date, setDate] = useState("");

  useEffect(() => {
    if (!uid) return;
    const unsub = subscribeUserInvoices(uid, setList);
    return () => unsub && unsub();
  }, [uid]);

  const onUpload = async () => {
    if (!file) return alert("Оберіть PDF");
    await uploadInvoicePdf(uid, file, date || new Date());
    setFile(null);
    setDate("");
  };

  return (
    <div
      style={{
        padding: 12,
        border: "1px solid #eee",
        borderRadius: 10,
        background: "#fafafa",
        marginTop: 8,
      }}
    >
      <div style={{ fontWeight: 700, marginBottom: 8 }}>
        Рахунки користувача
      </div>

      <div
        style={{
          display: "flex",
          gap: 8,
          alignItems: "center",
          marginBottom: 10,
        }}
      >
        <input
          type="date"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
        <input
          type="file"
          accept="application/pdf"
          onChange={(e) => setFile(e.target.files?.[0] || null)}
        />
        <button
          onClick={onUpload}
          disabled={!file}
          style={{ padding: "6px 10px", cursor: "pointer" }}
        >
          Завантажити рахунок
        </button>
      </div>

      {list.length === 0 ? (
        <div style={{ color: "#666" }}>Рахунків ще немає.</div>
      ) : (
        <ul
          style={{
            listStyle: "none",
            padding: 0,
            margin: 0,
            display: "grid",
            gap: 6,
          }}
        >
          {list.map((inv) => (
            <li
              key={inv.id}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "8px 10px",
                background: "#fff",
                border: "1px solid #eee",
                borderRadius: 8,
              }}
            >
              <div>
                <div style={{ fontWeight: 600 }}>
                  {inv.orderDate?.toDate
                    ? inv.orderDate.toDate().toLocaleDateString()
                    : new Date(inv.orderDate).toLocaleDateString()}
                </div>
                <div style={{ fontSize: 12, color: "#666" }}>
                  {inv.fileName}
                </div>
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                <a
                  href={`https://docs.google.com/gview?embedded=1&url=${encodeURIComponent(
                    inv.url
                  )}`}
                  target="_blank"
                  rel="noreferrer"
                  style={{
                    textDecoration: "none",
                    padding: "6px 10px",
                    border: "1px solid #3e51c1",
                    color: "#3e51c1",
                    borderRadius: 8,
                  }}
                >
                  Відкрити
                </a>
                <button
                  onClick={() => removeInvoice(uid, inv)}
                  style={{
                    padding: "6px 10px",
                    background: "#dc2626",
                    color: "#fff",
                    border: "none",
                    borderRadius: 8,
                    cursor: "pointer",
                  }}
                >
                  Видалити
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
